import {Box} from '@mui/material';

import {ProfileComparisonResultScoreCard} from './ProfileComparisonResultScoreCard';
import {profileComparisonResultScoreCardsSx} from './profileComparisonSectionStyles';
import type {ProfileComparisonDimensionDelta, ProfileComparisonSummary} from '../../types/ProfileComparisonTypes';

export interface Props {
  profileA: ProfileComparisonSummary;
  profileB: ProfileComparisonSummary;
  dimensionDeltas: ProfileComparisonDimensionDelta[];
}

export const ProfileComparisonResultScoreCards = ({profileA, profileB, dimensionDeltas}: Props) => (
  <Box sx={profileComparisonResultScoreCardsSx} data-testid='profile-comparison-score-cards'>
    <ProfileComparisonResultScoreCard slot='a' summary={profileA} dimensionDeltas={dimensionDeltas} />
    <ProfileComparisonResultScoreCard slot='b' summary={profileB} dimensionDeltas={dimensionDeltas} />
  </Box>
);
